import React from 'react';
import '../css/Techstack.css';

const techStack = {
  Languages: [
    { name: 'HTML5', icon: 'https://img.icons8.com/color/48/html-5.png' },
    { name: 'CSS3', icon: 'https://img.icons8.com/color/48/css3.png' },
    { name: 'JavaScript', icon: 'https://img.icons8.com/color/48/javascript.png' },
    { name: 'TypeScript', icon: 'https://img.icons8.com/color/48/typescript.png' },
    { name: 'Python', icon: 'https://img.icons8.com/color/48/python.png' },
    { name: 'C#', icon: 'https://img.icons8.com/color/48/c-sharp-logo.png' }
  ],
  Frameworks: [
        { name: 'React', icon: 'https://img.icons8.com/?size=48&id=bzf0DqjXFHIW&format=png&color=000000' },
        { name: '.NET', icon: 'https://img.icons8.com/?size=100&id=o0pte3XTuPWi&format=png&color=000000' },
  ],
  Strengths: [
    { name: 'Clean code', icon: 'https://img.icons8.com/?size=48&id=8rcWnS1m5Fe6&format=png&color=000000' },
    { name: 'Team work', icon: 'https://img.icons8.com/?size=48&id=OAs4QZ2x4zyX&format=png&color=000000' },
    { name: 'Work with deadlines', icon: 'https://img.icons8.com/?size=48&id=Qd1srbdHrhiX&format=png&color=000000' },
    { name: 'Self control under stress', icon: 'https://img.icons8.com/?size=48&id=oo0xsUn0tr0I&format=png&color=000000' },
    { name: 'No bugs left behind', icon: 'https://img.icons8.com/?size=48&id=iNamA11qJFJq&format=png&color=000000' },
    { name: 'Software upgrader', icon: 'https://img.icons8.com/?size=48&id=55162&format=png&color=000000' },
    { name: 'Remote work lover', icon: 'https://img.icons8.com/?size=48&id=107461&format=png&color=000000' },
    ],
  AIProductivity: [
        { name: 'Claude', icon: 'https://img.icons8.com/?size=100&id=zQjzFjPpT2Ek&format=png&color=000000' },
        { name: 'ChatGPT', icon: 'https://img.icons8.com/?size=100&id=ka3InxFU3QZa&format=png&color=000000' },
        { name: 'AI Agents', icon: 'https://img.icons8.com/?size=100&id=326&format=png&color=000000' },
  ],
  Tooling: [
    { name: 'Github', icon: 'https://img.icons8.com/?size=48&id=62856&format=png&color=000000' },
    { name: 'Bash', icon: 'https://img.icons8.com/?size=48&id=50ZQHdJTmPqw&format=png&color=000000' },
    { name: 'Confluence', icon: 'https://img.icons8.com/?size=48&id=h8EoAfgRDYLo&format=png&color=000000' },
    { name: 'Docker', icon: 'https://img.icons8.com/?size=48&id=22813&format=png&color=000000' },
    { name: 'TeamCity', icon: 'https://img.icons8.com/?size=48&id=pj15SuHu3Vlt&format=png&color=000000' },
    { name: 'Vercel', icon: 'https://img.icons8.com/?size=100&id=2xFS7aynbwiR&format=png&color=000000' },
    { name: 'LinuxTerminal', icon: 'https://img.icons8.com/?size=48&id=UjcGNVXknmz3&format=png&color=000000' },
    { name: 'DBeaver', icon: 'https://img.icons8.com/?size=48&id=kjaF4LlvyR6g&format=png&color=000000' },
    { name: 'Postman', icon: 'https://img.icons8.com/?size=48&id=EPbEfEa7o8CB&format=png&color=000000' },    
  ],
  Observability: [
    { name: 'Kibana', icon: 'https://img.icons8.com/?size=48&id=viVPreeQBfSH&format=png&color=000000' },
    { name: 'Grafana', icon: 'https://img.icons8.com/?size=48&id=bMkmDxPRZAld&format=png&color=000000' },
  ],
  Architecture: [
    { name: 'OOP', icon: 'https://img.icons8.com/?size=48&id=D8fI0PGNpq8i&format=png&color=000000' },
    { name: 'REST API', icon: 'https://img.icons8.com/?size=100&id=21888&format=png&color=000000' },
    { name: 'Load balancer', icon: 'https://img.icons8.com/?size=48&id=59368&format=png&color=000000' },
    { name: 'Client Server', icon: ' https://img.icons8.com/?size=48&id=kWEG6uycfU5o&format=png&color=000000' },
    { name: 'DevOps', icon: 'https://img.icons8.com/?size=48&id=CLa3T2WlbrOP&format=png&color=000000' },
    { name: 'Agile', icon: 'https://img.icons8.com/?size=48&id=e4N2brGHZDcd&format=png&color=000000' },
  ], 
  Cloud: [
    { name: 'AWS', icon: 'https://img.icons8.com/color/48/amazon-web-services.png' },
    { name: 'AWS Lambda', icon: 'https://img.icons8.com/?size=48&id=Y9Kxy8Xl1id8&format=png&color=000000' },
    { name: 'EC2', icon: 'https://icon.icepanel.io/AWS/svg/Compute/EC2.svg' },
    { name: 'ECS', icon: 'https://icon.icepanel.io/AWS/svg/Containers/Elastic-Container-Service.svg' },
    { name: 'IAM', icon: 'https://icon.icepanel.io/AWS/svg/Security-Identity-Compliance/Identity-and-Access-Management.svg' },
    { name: 'Secrets Manager', icon: 'https://icon.icepanel.io/AWS/svg/Security-Identity-Compliance/Secrets-Manager.svg' },
    { name: 'AWS CDK', icon: 'https://icon.icepanel.io/AWS/svg/Developer-Tools/Cloud-Development-Kit.svg' },
  ],
  Database: [
    { name: 'Postgres', icon: 'https://img.icons8.com/?size=48&id=38561&format=png&color=000000' },
    { name: 'SQLServer', icon: 'https://img.icons8.com/?size=48&id=laYYF3dV0Iew&format=png&color=000000' },
    { name: 'SQL', icon: 'https://img.icons8.com/?size=48&id=Hw6JjH8IYa7J&format=png&color=000000' },
  ],
  OS: [
    { name: 'Windows', icon: 'https://img.icons8.com/?size=48&id=22989&format=png&color=000000' },
    { name: 'Linux', icon: 'https://img.icons8.com/?size=48&id=17842&format=png&color=000000'}   
  ]
};

/* "AIProductivity" -> "AI Productivity", "OS" -> "OS" */
const formatCategory = (category) =>
  category
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-z\d])([A-Z])/g, '$1 $2');

const TechStack = () => {
  const total = Object.values(techStack).reduce((sum, items) => sum + items.length, 0);

  return (
    <section className="tech">
      <header className="section-head">
        <span className="section-eyebrow">{total} tools</span>
        <h1 className="section-title">Tech stack</h1>
      </header>

      {Object.entries(techStack).map(([category, items]) => (
        <section key={category} className="tech-category">
          <h2 className="tech-category-title">
            {formatCategory(category)}
            <span className="tech-category-count">{items.length}</span>
          </h2>
          <div className="tech-list">
            {items.map((tech, index) => (
              <div key={index} className="tech-item">
                <img src={tech.icon} alt="" loading="lazy" />
                <span>{tech.name}</span>
              </div>
            ))}
          </div>
        </section>
      ))}
    </section>
  );
};

export default TechStack;
